import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { startAuthTimer, clearAuthTimer } from '../utils/authTimer';
import { getTimeoutForUser } from '../utils/sessionConfig';

const AuthMonitor = () => {
  const userInfo = useSelector((state) => state.auth.userInfo);
  const dispatch  = useDispatch();
  const navigate  = useNavigate();

  useEffect(() => {
    if (!userInfo) return;

    // resetTimer now captures userInfo from the enclosing scope so it
    // uses the correct role-based timeout for this specific user.
    const resetTimer = () => {
      const timeout        = getTimeoutForUser(userInfo);
      const expirationTime = new Date().getTime() + timeout;
      localStorage.setItem('expirationTime', expirationTime);
    };

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keypress',  resetTimer);
    window.addEventListener('click',     resetTimer);

    startAuthTimer(dispatch, navigate);

    return () => {
      clearAuthTimer();
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keypress',  resetTimer);
      window.removeEventListener('click',     resetTimer);
    };
  }, [dispatch, navigate, userInfo]);

  return null;
};

export default AuthMonitor;